import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'app-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss']
})

export class SearchInputComponent implements OnInit, OnDestroy {
    @Output() debouncedInput = new EventEmitter<string>();
    @Input() debounceTime = 400;
    @ViewChild('searchInputBox', { static: true }) autocomplete: ElementRef;
    input$ = new Subject<Event>();
    private destroy$ = new Subject<void>();

    constructor() {
    }

    ngOnInit() {
        this.input$.pipe(
            map($event => $event.target['value']),
            debounceTime(this.debounceTime),
            distinctUntilChanged(),
            tap((text) => this.debouncedInput.emit(text)),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    // this method must be present, even if empty! for destroying subscriptions
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
